import { Question } from 'src/types/questionnaire.types';
import { QUESTIONNAIRE_MOCK } from '../mocks/questionnaire';
import { DoctorAppointment } from 'src/types/doctor-appointment.types';
import { VyduraReminder, VyduraSchedule } from 'src/types/vydura-reminder';
import { MigraineAttack } from 'src/types/migraine-attack.types';

type PopUpElement = () => React.JSX.Element;

export type State = {
  isPopUpOpened: boolean;
  PopUpContent: PopUpElement | null;
  PopUpFooter: PopUpElement | null;
  popUpHeader?: string;
  questionnaire: Question[];
  doctorAppointment?: DoctorAppointment;
  vyduraReminder?: VyduraReminder;
  migraineAttacks: MigraineAttack[];
  vyduraSchedule?: VyduraSchedule;
};

export const initialState = {
  isPopUpOpened: false,
  PopUpContent: null,
  PopUpFooter: null,
  questionnaire: QUESTIONNAIRE_MOCK,
  migraineAttacks: [],
};
